import ReducerUtils from "../../../utils/ReducerUtils"
import Actions from "../../../model/constant/actions"

const GeoBids = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_GEOBIDS_STATISTICS] : (_,action)=>action.status
})

export default GeoBids
